import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {RemotePostBeneficiaryToken} from 'data/usecases';
import {PostBeneficiaryToken} from 'domain/usecases';
import {BeneficiaryTokenEndpoints} from '../../endpoints';

export const makePostBeneficiaryToken = (): PostBeneficiaryToken =>
	new RemotePostBeneficiaryToken(
		makeBFFApiUrl(BeneficiaryTokenEndpoints.beneficiaryToken),
		makeAuthorizeHttpClientDecorator(),
	);
